import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiVisa, BasicApiResponseModel } from '../shared';
import { GenericDocLineContainerModel } from '../../../../../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeliveryChargesService extends BaseApiPublicLoginTemplateService<null, null, null> {

  static readonly DELIVERY_CHARGES_SUB_PATH = 'calculate-delivery-charge/'
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + DeliveryChargesService.DELIVERY_CHARGES_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + DeliveryChargesService.DELIVERY_CHARGES_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + DeliveryChargesService.DELIVERY_CHARGES_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + DeliveryChargesService.DELIVERY_CHARGES_SUB_PATH + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.httpClient = http;
  }

  generateDeliveryChargesDocLine(docGuid: string, itemGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<GenericDocLineContainerModel>> {
    let loginApiUrl = (this.endpoint_path && visa.api_domain_url ? visa.api_domain_url + this.endpoint_path : this.apiUrl) + `/${docGuid}` + `/${itemGuid}`;
    return this.httpClient.post<BasicApiResponseModel<GenericDocLineContainerModel>>(loginApiUrl, null, this.getHttpHeader(visa))
  }

  loginEntityGenerateDeliveryChargesDocLine(docGuid: string, itemGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<GenericDocLineContainerModel>> {
    let loginApiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + DeliveryChargesService.DELIVERY_CHARGES_SUB_PATH + BaseApiTemplateService.LOGIN_ENTITY_EP;
    let url = (this.endpoint_path_login_entity_url && visa.api_domain_url ? visa.api_domain_url + this.endpoint_path_login_entity_url : loginApiUrl) + `/${docGuid}` + `/${itemGuid}`;
    return this.httpClient.post<BasicApiResponseModel<GenericDocLineContainerModel>>(url, null, this.getHttpHeader(visa))
  }
}